import { render, staticRenderFns } from "./frame-visual-editor-panel.vue?vue&type=template&id=33bc8021&scoped=true&"
import script from "./frame-visual-editor-panel.vue?vue&type=script&lang=js&"
export * from "./frame-visual-editor-panel.vue?vue&type=script&lang=js&"
import style0 from "./frame-visual-editor-panel.vue?vue&type=style&index=0&id=33bc8021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc8021",
  null
  
)

export default component.exports